<template>
    <div class="program-detail-card mb-4">
        <p class="cards-title">description</p>
        <p class="card-text ">{{ description }}</p>
        <p class="cards-title">application</p>
        <p class="mb-3">{{ application }}</p>
        <img v-if="productImg !== ''" :src="require(`@/assets/images/${productImg}`)" :alt="description" class="product-image"/>
        
    </div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue';
defineProps(['description', 'application', 'productImg'])
</script>
<style lang="scss" scoped>
.product-image {
    max-width: 45%;
    float: right;
}
    
</style>